import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useOrderShippingTypePrice = () => {
    const { t } = useTwinTranslation()
    const orderShippingTypePrice: TwinDictionary ={
        0: { name: t('automatic', 'Automático') },
        1: { name: t('manualPrice', 'Precio manual') }
    }

    return orderShippingTypePrice
}

export default useOrderShippingTypePrice